import "core-js/modules/es.array.push.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "nav"
};
var _hoisted_2 = {
  class: "nav-top"
};
var _hoisted_3 = {
  class: "nav-top-logo"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "nav-top-tabs active"
};
var _hoisted_6 = {
  class: "nav-top-tabs-img"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "nav-avatar"
};
var _hoisted_9 = ["src"];
import { ref, computed, toRefs, watch } from 'vue';
import { getStore, removeStore } from '@/util/store';
import { useRouter } from 'vue-router';
import helpDialog from '@/components/HelpDialog/index.vue';
import WujieVue from 'wujie-vue3';
import { searchHelpCenter } from '@/api/menu';
export default {
  __name: 'navLeftNotice',
  props: {
    // 父组件传递的参数
    appInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var bus = WujieVue.bus;
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo

    var homeImg = require('@/assets/home.svg');
    var props = __props;
    var _toRefs = toRefs(props),
      appInfo = _toRefs.appInfo;
    var disabledList = ref(['helpCenter']);
    var visibleHelp = ref(false);
    var router = useRouter();
    var handleGoHome = function handleGoHome() {
      //判断当前是否存在JSAndroid方法，如果出现错误， 属于pc端
      if (window.JSAndroid) {
        window.JSAndroid.homeRefresh();
        window.JSAndroid.activityFinish();
      } else {
        router.push({
          path: '/'
        });
        bus.$emit('backHome');
      }
    };
    __expose({
      handleGoHome: handleGoHome
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, function () {
        return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          src: require("@/assets/nav/notice-app.svg")
        }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: require("@/assets/nav/notice-active.svg")
        }, null, 8, _hoisted_7)]), _cache[0] || (_cache[0] = _createElementVNode("div", null, "消息通知", -1))])])];
      }), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: "nav-avatar-home",
        onClick: handleGoHome
      }, [_createElementVNode("img", {
        src: _unref(homeImg)
      }, null, 8, _hoisted_9)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "nav-avatar-text"
      }, "回首页", -1))])]);
    };
  }
};